module.exports = __webpack_public_path__ + "img/Mexico.7796e226.svg";